<template>
  <div>
    <NewHeader />
    <div class="container">
      <h4 class="text-center mt-5 mb-5">Pastoral Team</h4>
      <div class="d-flex">
        <div v-for="(team, teamIndex) in pastoralTeam" :key="teamIndex" :class="[ teamIndex > 0 ? 'ml-5' : '' ]">
             <figure>
            <img :src= team.imgSrc :alt= team.alt width="250px" height="300px">
          </figure>

          <p class="pb-0 mb-0 font-weight-bold">{{team.title}}</p>
          <p>{{team.name}}</p>
        </div>
      </div>


      <div class="mt-5 mb-5">
          <ul>
              <li>Oblate Sisters of St. Joseph</li>
              <li>Parish Catechist: Ajayi-Choco Joseph</li>
              <li>Parish Pastoral Council Vice-chairman: Mr. Obinna Owulu</li>
              <li>Parish Finance Council Vice-chairman: Mr. A.C Nwachukwu</li>
              <li>Parish Laity Council Chairman: Mr Ken Duru</li>
          </ul>
      </div>

      <!-- <div>
        Parish Pastoral Council
        Parish Laity Chairman
        Parish Finance Council
      </div> -->



    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/navigation/Header.vue';
import Footer from '@/components/navigation/Footer.vue';
import NewHeader from '@/components/navigation/NewHeader.vue';
import { pastoral } from '@/Data/pastoral.js';

export default {
     data() {
    return {
      pastoralTeam: []
    }

  },
  components: {
    Header,
    Footer,
    NewHeader
  },
   created() {
    pastoral.forEach((team) => {
      this.pastoralTeam.push(team)
    })
  }
};
</script>

<style scoped>
ul li {
    margin: 0;
    padding: 0;
}
ul {
     margin: 0;
    padding: 0;
}
</style>
